import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Calendar({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M6.00008 4.66667V6.66667H7.33342V2H6.00008V3.33333H4.66675C3.56218 3.33333 2.66675 4.22876 2.66675 5.33333V10H20.0001V18.6667C20.0001 19.0349 19.7016 19.3333 19.3334 19.3333H4.66675C4.29856 19.3333 4.00008 19.0349 4.00008 18.6667L4.00008 12H2.66675V18.6667C2.66675 19.7712 3.56218 20.6667 4.66675 20.6667H19.3334C20.438 20.6667 21.3334 19.7712 21.3334 18.6667V5.33333C21.3334 4.22876 20.438 3.33333 19.3334 3.33333H18.6667V4.66667H19.3334C19.7016 4.66667 20.0001 4.96514 20.0001 5.33333V8.66667H4.00008V5.33333C4.00008 4.96514 4.29856 4.66667 4.66675 4.66667H6.00008Z"
        fill={iconColor}
      />
      <Path
        d="M8.66675 4.66667H16.0001V6.66667H17.3334V2H16.0001V3.33333H8.66675V4.66667Z"
        fill={iconColor}
      />
      <Path d="M8.00008 12H6.00008V14H8.00008V12Z" fill={iconColor} />
      <Path
        d="M6.00008 15.3333H8.00008V17.3333H6.00008V15.3333Z"
        fill={iconColor}
      />
      <Path d="M18.0001 12H16.0001V14H18.0001V12Z" fill={iconColor} />
      <Path
        d="M16.0001 15.3333H18.0001V17.3333H16.0001V15.3333Z"
        fill={iconColor}
      />
      <Path d="M13.0001 12H11.0001V14H13.0001V12Z" fill={iconColor} />
      <Path
        d="M11.0001 15.3333H13.0001V17.3333H11.0001V15.3333Z"
        fill={iconColor}
      />
    </Svg>
  );
}
